<template>
  <div
    tabindex="0"
    class="IUpload"
    :class="[
      fileName ? '' : 'tw-cursor-pointer',
      disabled ? 'tw-pointer-events-none tw-cursor-not-allowed' : '',
      maxFilenameLabelLength
    ]"
    @click="fileName ? null : triggerUpload()"
  >
    <div class="tw-flex tw-items-center">
      <icon-attachment
        v-if="fileName"
        class="tw-mr-2"
        :class="[
          disabled ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : ''
        ]"
      />
      <el-tooltip
        v-if="fileName?.length > maxFilenameLabelLength"
        :content="fileName"
      >
        <span
          :class="[
            fileName ? '' : 'tw-text-gray-dark dark:tw-text-dm-gray-dark',
            disabled ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : ''
          ]"
        >
          {{ fileName.substring(0, maxFilenameLabelLength - 3) }}...
        </span>
      </el-tooltip>
      <div
        v-else
        :class="[
          fileName ? '' : 'tw-text-gray-dark dark:tw-text-dm-gray-dark',
          disabled ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : ''
        ]"
      >
        {{ fileName || $capitalize($t('common.fields.file')) }}
      </div>
    </div>
    <div
      v-if="fileName"
      class="tw-flex tw-gap-2"
    >
      <i-confirm-popover
        :cancel-text="$t('common.actions.cancel')"
        :submit-text="$t('common.actions.delete')"
        @submit="clear"
      >
        <template #reference>
          <i-button
            type="white"
            size="small"
            is-icon
          >
            <icon-trash
              class="tw-w-4"
              :class="[
                disabled ? 'tw-text-gray-dark dark:tw-text-dm-gray-dark' : ''
              ]"
            />
          </i-button>
        </template>
        <template #content>
          <div>
            {{ $t('common.fields.file_delete_confirmation') }}
          </div>
        </template>
      </i-confirm-popover>
    </div>
    <i-button
      v-else
      type="primary"
      size="small"
      :disabled="disabled"
      is-icon
      @click.stop="triggerUpload()"
    >
      <icon-upload class="tw-w-4" />
    </i-button>
    <input
      ref="File"
      type="file"
      :multiple="multiple"
      hidden
      :disabled="disabled"
      @change="uploadFile"
    >
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxFilenameLabelLength: {
      type: Number,
      default: 25,
    },
  },

  data() {
    return {
      fileName: '',
      files: [],
    };
  },

  watch: {
    value: {
      immediate: true,
      handler() {
        this.fileName = this.value;
      },
    },
  },

  methods: {
    triggerUpload() {
      if (this.fileName) return;
      this.$refs.File.click();
    },
    uploadFile(event) {
      this.files = event.target.files;
      if (!this.files.length) {
        return;
      }

      if (this.multiple) {
        this.fileName = this.files.length === 1 ? this.files[0].name : `${this.files.length} files`;
        this.$emit('changed', [...this.files]);
      } else {
        this.fileName = this.files[0].name;
        this.$emit('changed', this.files[0]);
      }

      event.target.value = null;
    },
    clear() {
      this.files = [];
      this.fileName = '';
      this.$emit('changed', this.multiple ? [] : null);
    },
  },
};
</script>

<style lang="scss" scoped>
.IUpload {
  @apply tw-h-14 tw-w-full tw-rounded-xl tw-bg-light dark:tw-bg-dm-light hover:tw-bg-light-hover dark:hover:tw-bg-dm-gray tw-flex tw-px-5 tw-items-center tw-justify-between tw-transition tw-tracking-normal;
}
</style>
